import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContrast02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm20 0c0 4.427-3.197 8.108-7.408 8.86-.454.08-.68.121-.933.03a1.108 1.108 0 0 1-.525-.44C12 20.218 12 19.945 12 19.4V4.6c0-.545 0-.818.134-1.05.106-.183.327-.368.525-.44.253-.091.48-.05.933.03C17.803 3.892 21 7.573 21 12Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgContrast02.displayName = 'Contrast02';
export default SvgContrast02;
